import moment from 'moment'
import { forwardRef } from 'react'
import WithReports from './WithReports'
import toUpper from 'lodash/toUpper'
import { formateDate } from 'utils'
import { Tooltip } from 'antd'
import { useHistory } from 'react-router-dom'
import Blockies from 'react-blockies'
import { useTranslation } from 'react-i18next'

// eslint-disable-next-line
const ActivityLogs = forwardRef(({ ...props }, ref) => {
  const history = useHistory()
  const { t } = useTranslation()

  const getLogType = type => {
    switch (type) {
      case 'direct':
        return t('activityLogs.logTypes.direct')
      case 'moonpay':
        return t('activityLogs.logTypes.moonpay')
      case 'moonpay_asset_info':
        return t('activityLogs.logTypes.moonpayAssetInfo')
      case 'moonpay_mint':
        return t('activityLogs.logTypes.moonpayMint')
      case 'admin':
        return t('activityLogs.logTypes.admin')
      case 'user':
        return t('activityLogs.logTypes.user')
      case null:
        return t('activityLogs.logTypes.default')
      default:
        return type
    }
  }

  const getActionTranslation = action => {
    if (!action) return action
    // eslint-disable-next-line
    const actionLower = action.toLowerCase()
    // eslint-disable-next-line
    if (actionLower.includes('add')) {
      return t('activityLogs.actions.add')
      // eslint-disable-next-line
    } else if (actionLower.includes('delete')) {
      return t('activityLogs.actions.delete')
      // eslint-disable-next-line
    } else if (actionLower.includes('update')) {
      return t('activityLogs.actions.update')
      // eslint-disable-next-line
    } else if (actionLower.includes('create')) {
      return t('activityLogs.actions.create')
      // eslint-disable-next-line
    } else if (actionLower.includes('remove')) {
      return t('activityLogs.actions.remove')
      // eslint-disable-next-line
    } else if (actionLower.includes('modify')) {
      return t('activityLogs.actions.modify')
    }

    return action
  }

  const columns = [
    {
      name: t('activityLogs.columns.type'),
      width: '100%',
      key: 'logType',
      sortable: false,
      rendered: item => (
        <div className="text-sm items-center bg-[#f3f3f3] flex text-gray-500 ">
          <div className="flex justify-center h-full w-[290px] ml-2 bg-[#f3f3f3] items-center mr-3">
            <span className="text-[12px] py-2 px-2 font-mono rounded-lg text-gray-500">
              {toUpper(getLogType(item.logType))}{' '}
              <span className="">
                {formateDate(moment(item.createdAt))} {moment(item.createdAt).fromNow()}
              </span>
            </span>
          </div>
          <div className="w-full flex px-3 items-center ">
            <div className="flex items-center">
              <span className="cursor-pointer" onClick={item?.updatedBy?._id ? () => history.push(`/users/edit/${item?.updatedBy?._id}/user-profile?t=2`) : null}>
                {item?.updatedBy?.avatar ? (
                  <img className="h-8 w-8 rounded-full mr-2" src={item?.updatedBy?.avatar} alt="" />
                ) : (
                  <Blockies className="rounded-full mr-2" seed={item.walletAddress || item.email || ''} size={5.5} scale={6} />
                )}
              </span>
              <span
                style={{ borderBottom: '1px dashed #dedede' }}
                className="font-regular text-[12px] block font-mono"
                onClick={item?.updatedBy?._id ? () => history.push(`/users/edit/${item?.updatedBy?._id}/user-profile?t=2`) : null}
              >
                {item.updatedBy?.fullName || item.updatedBy?.email || item.updatedBy?.phone || t('activityLogs.defaultUser')}
              </span>
              <div className="ml-4 flex justify-center h-full items-center ml-3">
                <span
                  className={`text-[10px] py-0.6 px-1 font-mono rounded-lg ${
                    // eslint-disable-next-line
                    item.action?.toLowerCase().includes('add')
                      ? 'bg-green-500 text-white'
                      : // eslint-disable-next-line
                      item.action?.toLowerCase().includes('delete')
                      ? 'bg-red-500 text-white'
                      : // eslint-disable-next-line
                      item.action?.toLowerCase().includes('update')
                      ? 'bg-yellow-500 text-black'
                      : 'bg-gray-500 text-white'
                  }`}
                >
                  {getActionTranslation(item.action)}
                </span>
              </div>
              <div className="ml-4 flex justify-center max-w-full items-center">
                <span className="text-[10px] py-2 px-2 font-mono rounded-lg text-gray-500 whitespace-normal  max-w-[800px]">{item.message}</span>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ]

  const headers = [
    { label: t('activityLogs.columns.type'), key: 'logType' },
    { label: t('activityLogs.columns.description'), key: 'shortDescription' },
    { label: t('activityLogs.columns.date'), key: 'createdAt' },
  ]
  const bgRow = 'bg-[#f3f3f3]'

  return (
    <WithReports
      filters={false}
      {...props}
      apiURL="audits"
      defaultFileName={t('activityLogs.title')}
      forwardedRef={ref}
      headers={headers}
      columns={columns}
      bgRow={bgRow}
      activeFilterName="past_7_days"
    />
  )
})

export default ActivityLogs
